export default __webpack_public_path__ + "static/media/footer-logo-text.8fa61c27.svg";